// removed by extract-text-webpack-plugin
module.exports = {"panel-view":"NotificationPanel__panel-view","panelView":"NotificationPanel__panel-view"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/panels/NotificationPanel/NotificationPanel.desktop.css
// module id = 1399
// module chunks = 8